import Box from 'UIKit/Box/Box'
import { BoxProps } from 'UIKit/Box/types'
import Popper from 'UIKit/Popper'
import { LANGUAGES } from 'config/constants/languages'
import useToggle from 'hooks/useToggle'
import React, { useCallback, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { animated, useSpring } from 'react-spring'
import styled from 'styled-components'
import { getIcon, Icons } from 'svgs'
import theme from 'theme'
import LanguagePopup from './components/LanguageSelector'
import { StyledLangugeSelected } from './style'

const LanguageSelectTopbar: React.FC<{ small?: boolean } & BoxProps> = ({ small, ...props }) => {
  const [shouldRenderDropdown, setShouldRenderDropdown] = useState(false)
  const [toggle, setToggle] = useToggle(false)
  const { i18n } = useTranslation()

  const selectedLanguage = useMemo(
    () => LANGUAGES.find((item) => item.code.toLowerCase() === i18n.language?.toLowerCase()),
    [i18n.language],
  )

  const Logo = getIcon(selectedLanguage?.logo)

  const dropdownSpring = useSpring({
    opacity: toggle ? 1 : 0,
    transform: toggle ? 'translateY(0px)' : 'translateY(20px)',
    config: { tension: 300, friction: 24, duration: 150 },
    onResolve: () => {
      if (!toggle) {
        setShouldRenderDropdown(false)
      }
    },
  })

  const handleToggle = useCallback(() => {
    setToggle()

    if (!toggle) setShouldRenderDropdown(true)
  }, [toggle])

  return (
    <Box {...props}>
      <Popper
        style={{
          width: 'max-content',
        }}
        open={shouldRenderDropdown}
        setOpen={handleToggle}
        dropdownContent={
          <animated.div style={dropdownSpring}>
            <LanguagePopup mt="6px" />
          </animated.div>
        }
        dropdownPosition="bottom-right"
        id="language-selected"
        className="language-selector"
      >
        <StyledLangugeSelected $Small={small} alignItems="center">
          <Logo style={{ borderRadius: '50%' }} />

          <Box width="8px" />
          {!small && <StyledArrowDownIcon $toggle={toggle} fill={theme.colors.textSubtle} />}
        </StyledLangugeSelected>
      </Popper>
    </Box>
  )
}

const StyledArrowDownIcon = styled(Icons.ArrowDownIcon)<{ $toggle: boolean }>`
  transition: ${({ theme }) => theme.transitions.fast};
  transform: ${({ $toggle }) => ($toggle ? 'rotate(180deg)' : 'rotate(0deg)')};
`

export default LanguageSelectTopbar
